import { render, staticRenderFns } from "./XcqNoImg.vue?vue&type=template&id=071a97c3&scoped=true&"
import script from "./XcqNoImg.vue?vue&type=script&lang=ts&"
export * from "./XcqNoImg.vue?vue&type=script&lang=ts&"
import style0 from "./XcqNoImg.vue?vue&type=style&index=0&id=071a97c3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071a97c3",
  null
  
)

export default component.exports